import React from 'react'

export default function NotFoundPage() {
    const style = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
    };

    return (
        <div style={style}>
            <h1 >There's not thing here</h1>
        </div>
    )
}
